import type { components } from '@/shared/api/schema'

export const feeBase = '/api/v1/procurement/landed-costs'
export const feeReadPermissions = ['procurement.view_landedcost', 'procurement.view_purchase_amount', 'procurement.view_purchasereceipt']
export type FeeDraft = components['schemas']['FeeDraftInput']
export type FeeDocument = components['schemas']['FeeDraftOutput']
export type FeePreview = components['schemas']['FeePreviewOutput']
export type FeeCandidate = components['schemas']['FeeCandidateOutput']
export type PendingFee = { body: string; key: string; documentId?: number; action?: 'submit' | 'approve' | 'reject' | 'withdraw' | 'request-reversal' | 'approve-reversal' | 'reject-reversal' | 'withdraw-reversal' }
export function parsePendingFee(raw: string): PendingFee {
  const value = JSON.parse(raw) as PendingFee
  if (!value || typeof value.body !== 'string' || value.body.length > 300000 ||
    typeof value.key !== 'string' || !/^[0-9a-f-]{36}$/i.test(value.key)) throw new Error('Invalid pending request')
  if (value.action !== undefined) {
    if (!['submit', 'approve', 'reject', 'withdraw', 'request-reversal', 'approve-reversal', 'reject-reversal', 'withdraw-reversal'].includes(value.action)
      || !Number.isSafeInteger(value.documentId) || Number(value.documentId) < 1) throw new Error('Invalid action recovery')
    const body = JSON.parse(value.body) as { expected_version: number; comment: string; approval_id?: number }
    if (!body || !Number.isSafeInteger(body.expected_version) || body.expected_version < 1
      || typeof body.comment !== 'string' || body.comment.length > 2000)
      throw new Error('Invalid review recovery')
    const needsApproval = !['submit', 'request-reversal'].includes(value.action)
    if (needsApproval && (!Number.isSafeInteger(body.approval_id) || Number(body.approval_id) < 1))
      throw new Error('Invalid review recovery')
    if (value.action === 'request-reversal' && (!(body as { reason?: string }).reason || typeof (body as { reason?: string }).reason !== 'string'))
      throw new Error('Invalid reversal recovery')
    return { body: value.body, key: value.key, documentId: value.documentId, action: value.action }
  }
  const body = JSON.parse(value.body) as FeeDraft
  if (!body || typeof body !== 'object' || !Array.isArray(body.lines) || !Array.isArray(body.sources)
    || !Number.isSafeInteger(body.supplier_id)) throw new Error('Invalid pending body')
  if (value.documentId !== undefined && (!Number.isSafeInteger(value.documentId) || value.documentId < 1
    || !Number.isSafeInteger((body as FeeDraft & { expected_version?: number }).expected_version))) throw new Error('Invalid edit recovery')
  return { body: value.body, key: value.key, ...(value.documentId === undefined ? {} : { documentId: value.documentId }) }
}
